export const START_PROCESS = "START_PROCESS"
export const END_PROCESS = "END_PROCESS"
